export enum ORDER_HISTORY_TYPE {
	Created = 0,
	AddedCandidate = 1,
	RejectedCandidate = 2,
	RejectedCandidateCancel = 3,
	TempWorkerAgreed = 4,
	TempWorkerDisagreed = 5,
	ClientAgreed = 6,
	ClientDisagreed = 7,
	Canceled = 8,
	ClientProposal = 9,
	TempWorkerProposal = 10,
	Filled = 11,
	Validated = 12,
}
